import React from 'react';
import { Send, Globe } from 'lucide-react';
export function Footer() {
  return <footer className="bg-[#11111f] text-gray-400 py-16 border-t border-gray-800" data-id="element-27">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-28">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12" data-id="element-29">
          {/* Brand */}
          <div data-id="element-30">
            <h3 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-31">
              新加坡幸福缘
            </h3>
            <p className="text-sm leading-relaxed mb-6" data-id="element-32">
              Singapore Happiness Connection
              <br data-id="element-33" />
              致力于为您提供最优质的按摩与伴游服务，让您的身心得到彻底的放松。
            </p>
            <div className="flex space-x-4" data-id="element-34">
              <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors flex items-center gap-2" data-id="element-35">
                <Send size={18} data-id="element-36" />
                <span className="text-sm" data-id="element-37">Telegram</span>
              </a>
              <a href="https://www.geylang777-2.site" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors flex items-center gap-2" data-id="element-38">
                <Globe size={18} data-id="element-39" />
                <span className="text-sm" data-id="element-40">官网</span>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div data-id="element-41">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-42">
              Quick Links
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-43">
              <li data-id="element-44">
                <a href="#hero" className="hover:text-[#c9a96e] transition-colors" data-id="element-45">
                  首页 (Home)
                </a>
              </li>
              <li data-id="element-46">
                <a href="#services" className="hover:text-[#c9a96e] transition-colors" data-id="element-47">
                  服务 (Services)
                </a>
              </li>
              <li data-id="element-48">
                <a href="#therapists" className="hover:text-[#c9a96e] transition-colors" data-id="element-49">
                  技师 (Therapists)
                </a>
              </li>
              <li data-id="element-50">
                <a href="https://t.me/gl777net" target="_blank" rel="noopener noreferrer" className="hover:text-[#c9a96e] transition-colors" data-id="element-51">
                  预约 (Book Now)
                </a>
              </li>
            </ul>
          </div>

          {/* Hours */}
          <div data-id="element-52">
            <h4 className="text-white font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-53">
              Service Hours
            </h4>
            <ul className="space-y-3 text-sm" data-id="element-54">
              <li className="flex justify-between" data-id="element-55">
                <span data-id="element-56">Monday - Sunday</span>
                <span className="text-white" data-id="element-57">24 Hours</span>
              </li>
              <li className="mt-4 text-xs text-gray-500" data-id="element-58">
                * Public holidays open as usual
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center text-xs text-gray-600" data-id="element-59">
          <p data-id="element-60">
            &copy; {new Date().getFullYear()} Singapore Happiness Connection.
            All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0" data-id="element-61">
            <a href="#" className="hover:text-gray-400" data-id="element-62">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-gray-400" data-id="element-63">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>;
}